var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardOrigin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.832024 0C0.592024 0 0.400024 0.183051 0.400024 0.404237V6.29237C0.400024 6.52119 0.592024 6.70424 0.832024 6.70424C1.07202 6.70424 1.26402 6.52119 1.26402 6.29237V0.404237C1.25602 0.183051 1.06402 0 0.832024 0Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35206 2.40254C6.54406 2.66187 5.76006 1.80763 4.65606 0.678815C3.42406 -0.572032 2.22406 0.236442 1.88806 0.518646V4.05C1.92006 4.06526 1.96006 4.06526 1.99206 4.03475C2.57606 3.32543 3.43206 3.17288 4.37606 3.67627C5.47206 4.26356 6.60806 3.80593 7.04806 3.37882C7.24006 3.19576 7.42406 2.92119 7.57606 2.66949C7.66406 2.53221 7.52006 2.35678 7.35206 2.40254Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOrigin);
export default __webpack_public_path__ + "static/media/card-origin.66b656e0ca1fa3842fcba28042c62567.svg";
export { ForwardRef as ReactComponent };